import React from 'react';
import { calcDomainScore } from '../../utils/scoring';

const Roadmap = ({ setPage, scores }) => {
  const printScore = calcDomainScore(scores, 'P');
  const itScore = calcDomainScore(scores, 'I');
  const cyberScore = calcDomainScore(scores, 'C');

  const buildPhases = () => {
    const phases = [
      { number: 1, title: 'STABILIZE', timing: '0–90 Days', color: 'bg-[#DC3545]', textColor: 'text-white', items: [] },
      { number: 2, title: 'STANDARDIZE', timing: '90–180 Days', color: 'bg-[#FD7E14]', textColor: 'text-white', items: [] },
      { number: 3, title: 'OPTIMIZE', timing: '6–12 Months', color: 'bg-[#FFC107]', textColor: 'text-gray-900', items: [] },
      { number: 4, title: 'INNOVATE', timing: '12+ Months', color: 'bg-[#28A745]', textColor: 'text-white', items: [] }
    ];

    if (cyberScore < 3) {
      phases[0].items.push({ icon: '🔐', text: 'Implement MFA across all users and systems' });
      phases[0].items.push({ icon: '🛡️', text: 'Deploy endpoint protection (EDR)' });
    }
    if (itScore < 3) {
      phases[0].items.push({ icon: '💾', text: 'Establish backup and recovery baseline' });
      phases[0].items.push({ icon: '📱', text: 'Deploy endpoint management (MDM)' });
    }
    if (printScore < 3) {
      phases[0].items.push({ icon: '🖨️', text: 'Conduct print fleet assessment' });
    }

    if (printScore < 4) {
      phases[1].items.push({ icon: '🖨️', text: 'Implement Managed Print Services' });
      phases[1].items.push({ icon: '📄', text: 'Deploy secure print release' });
    }
    if (itScore < 4) {
      phases[1].items.push({ icon: '☁️', text: 'Execute cloud migration roadmap' });
      phases[1].items.push({ icon: '🔧', text: 'Transition to managed IT services' });
    }
    if (cyberScore < 4) {
      phases[1].items.push({ icon: '👥', text: 'Launch security awareness training' });
    }

    phases[2].items.push(
      { icon: '📊', text: 'Implement reporting and analytics' },
      { icon: '⚡', text: 'Automate routine processes' },
      { icon: '📈', text: 'Optimize costs and performance' }
    );

    phases[3].items.push(
      { icon: '🤖', text: 'AI-driven insights and automation' },
      { icon: '🎯', text: 'Strategic technology alignment (vCIO)' },
      { icon: '🔮', text: 'Predictive maintenance and operations' }
    );

    return phases;
  };

  const phases = buildPhases();

  return (
    <div className="animate-fade-in space-y-6">
      <div className="bg-white rounded-2xl p-8 shadow-sm">
        <h1 className="text-2xl md:text-3xl font-bold text-[#2E5FA7] mb-2">Technology Transformation Roadmap</h1>
        <p className="text-gray-600">Based on your alignment review, here is a phased approach to address gaps and achieve your business objectives.</p>
      </div>

      <div className="space-y-4">
        {phases.map((phase) => (
          <div key={phase.number} className="bg-white rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
            <div className={`p-4 flex items-center gap-4 ${phase.color} ${phase.textColor}`}>
              <div className="bg-white/20 w-8 h-8 rounded-full flex items-center justify-center font-bold">
                {phase.number}
              </div>
              <div className="font-bold text-lg tracking-wide">{phase.title}</div>
              <div className="ml-auto text-sm opacity-90 font-medium">{phase.timing}</div>
            </div>
            <div className="p-5">
              {phase.items.length > 0 ? (
                <div className="space-y-3">
                  {phase.items.map((item, idx) => (
                    <div key={idx} className="flex items-start gap-3 text-sm text-gray-700">
                      <span className="text-lg leading-none">{item.icon}</span>
                      <span className="leading-snug">{item.text}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-gray-500 italic text-sm">No immediate actions required in this phase.</div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-between mt-8 pb-8">
        <button onClick={() => setPage('insights')} className="px-6 py-3 rounded-lg font-semibold text-[#2E5FA7] border-2 border-[#2E5FA7] hover:bg-gray-50 transition-all">← Back</button>
        <button onClick={() => setPage('summary')} className="px-6 py-3 rounded-lg font-semibold bg-[#2E5FA7] text-white hover:bg-[#244C86] transition-all shadow-md">View Executive Summary →</button>
      </div>
    </div>
  );
};

export default Roadmap;